import React from "react";
import ReactDOM from "react-dom";
import "./index.sass";
import { App } from "./components/app";

ReactDOM.render(<App />, document.getElementById("root"));
